import * as React from "react";
import styled, { css } from "styled-components";
import { useTranslation } from "react-i18next";
import Icon from "components/common/Icon";
import Spinner from "components/common/Spinner";
import { formatDuration, toolCallLabel } from "./toolCallLabels";
const List = styled.ul(
  ({ theme }) => css`
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings.xxs};
    font-size: ${theme.fonts.size.small};
    color: ${theme.colors.text.secondary};
  `
);
const Item = styled.li(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.spacings.xs};
  `
);
const Failed = styled.span(
  ({ theme }) => css`
    color: ${theme.colors.variant.warning};
  `
);
const Status = ({ call }) => {
  const { t } = useTranslation("enterprise_ai");
  const label = toolCallLabel(call.tool);
  if (call.status === "running") {
    return /* @__PURE__ */ React.createElement(Spinner, { text: t("tool_call_list.running", { label }), delay: 0 });
  }
  const duration = call.durationMs === void 0 ? null : ` (${formatDuration(call.durationMs)})`;
  return call.status === "failed" ? /* @__PURE__ */ React.createElement(Failed, null, /* @__PURE__ */ React.createElement(Icon, { name: "warning" }), " ", t("tool_call_list.failed", { label }), duration) : /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(Icon, { name: "check" }), " ", label, duration);
};
const ToolCallList = ({ calls }) => {
  const { t } = useTranslation("enterprise_ai");
  return calls.length === 0 ? null : /* @__PURE__ */ React.createElement(List, { "aria-label": t("tool_call_list.aria_label") }, calls.map((call) => /* @__PURE__ */ React.createElement(Item, { key: call.id }, /* @__PURE__ */ React.createElement(Status, { call }))));
};
export default ToolCallList;
